import axios from 'axios';
import type { BundleData } from '../types/apiTypes';

export const bundleDataLookup = async (variantId: string | number): Promise<BundleData | null> => {
  try {
    const response = await axios.post('/api/bundle-data-lookup', { variantId });
    return response.data;
  } catch (error: unknown) {
    console.error(`Error fetching SKU for variantId ${variantId}:`, error);
    return null;
  }
}
